(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[229],{

/***/ 6394:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgBell = function SvgBell(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M10 2a6 6 0 0 0-6 6v3.586l-.707.707A1 1 0 0 0 4 14h12a1 1 0 0 0 .707-1.707L16 11.586V8a6 6 0 0 0-6-6zm0 16a3 3 0 0 1-3-3h6a3 3 0 0 1-3 3z"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    d: "M1.845 8.877c-.552.009-1.012-.434-.973-.985.22-3.078 1.666-5.148 2.891-6.215.417-.363 1.03-.198 1.305.281.274.48.11 1.102-.277 1.496-.778.795-1.712 2.244-1.91 4.408-.05.55-.484 1.006-1.036 1.015zm16.224-.324c.552-.007.999-.462.944-1.012-.308-3.07-1.811-5.098-3.067-6.13-.426-.351-1.035-.168-1.296.319-.26.486-.078 1.103.32 1.487.8.772 1.775 2.194 2.034 4.351.066.548.512.992 1.064.985z",
    clipRule: "evenodd"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgBell);

/***/ }),

/***/ 308:
/***/ (function(module) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),

/***/ 4309:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/home",
      function () {
        return __webpack_require__(8004);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7348:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "NA": function() { return /* binding */ withSession; },
/* harmony export */   "aF": function() { return /* binding */ useUser; },
/* harmony export */   "wF": function() { return /* binding */ isUnclaimed; }
/* harmony export */ });
/* unused harmony exports UserContext, useAuthenticatedUser, IfAuthenticated, IfGuest, UserProvider */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(692);
/* harmony import */ var posthog_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7294);
/* harmony import */ var react_use__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3742);
/* harmony import */ var _utils_trpc__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3757);
/* harmony import */ var _use_required_context__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8355);
/* provided dependency */ var process = __webpack_require__(3454);







const UserContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_3__.createContext(null);
const useUser = ()=>{
    return (0,_use_required_context__WEBPACK_IMPORTED_MODULE_5__/* .useRequiredContext */ .a)(UserContext, "UserContext");
};
const useAuthenticatedUser = ()=>{
    const { user , ...rest } = useRequiredContext(UserContext, "UserContext");
    if (user.isGuest) {
        throw new Error("Forget to prefetch user identity");
    }
    return {
        user,
        ...rest
    };
};
const IfAuthenticated = (props)=>{
    const { user  } = useUser();
    if (user.isGuest) {
        return null;
    }
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: props.children
    });
};
const IfGuest = (props)=>{
    const { user  } = useUser();
    if (!user.isGuest) {
        return null;
    }
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: props.children
    });
};
const UserProvider = (props)=>{
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)("app");
    const queryClient = _utils_trpc__WEBPACK_IMPORTED_MODULE_4__/* .trpcNext.useContext */ .G.useContext();
    const { data: user  } = _utils_trpc__WEBPACK_IMPORTED_MODULE_4__/* .trpcNext.whoami.get.useQuery */ .G.whoami.get.useQuery();
    const [isUpdating, setIsUpdating] = react__WEBPACK_IMPORTED_MODULE_3__.useState(false);
    const logout = _utils_trpc__WEBPACK_IMPORTED_MODULE_4__/* .trpcNext.whoami.destroy.useMutation */ .G.whoami.destroy.useMutation({
        onSuccess: async ()=>{
            setIsUpdating(true);
            await queryClient.whoami.invalidate();
            setIsUpdating(false);
        }
    });
    (0,react_use__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(()=>{
        var _process_env_NEXT_PUBLIC_POSTHOG_API_KEY;
        posthog_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"].init */ .ZP.init((_process_env_NEXT_PUBLIC_POSTHOG_API_KEY = process.env.NEXT_PUBLIC_POSTHOG_API_KEY) !== null && _process_env_NEXT_PUBLIC_POSTHOG_API_KEY !== void 0 ? _process_env_NEXT_PUBLIC_POSTHOG_API_KEY : "fake token", {
            api_host: process.env.NEXT_PUBLIC_POSTHOG_API_HOST,
            opt_out_capturing_by_default: false,
            capture_pageview: false,
            capture_pageleave: false,
            autocapture: false,
            loaded: (posthog)=>{
                if (!process.env.NEXT_PUBLIC_POSTHOG_API_KEY) {
                    posthog.opt_out_capturing();
                }
                if (user && posthog.get_distinct_id() !== user.id) {
                    posthog.identify(user.id, !user.isGuest ? {
                        email: user.email,
                        name: user.name
                    } : {
                        name: user.id
                    });
                }
            }
        });
    });
    const shortName = user ? user.isGuest === false ? user.name : user.id.substring(0, 10) : t("guest");
    if (!user) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UserContext.Provider, {
        value: {
            isUpdating,
            user: {
                ...user,
                shortName
            },
            refresh: ()=>{
                return queryClient.whoami.invalidate();
            },
            ownsObject: (param)=>{
                let { userId  } = param;
                if (userId && user.id === userId) {
                    return true;
                }
                return false;
            },
            logout: ()=>{
                logout.mutate();
            }
        },
        children: props.children
    });
};
// eslint-disable-next-line @typescript-eslint/ban-types
const withSession = (component)=>{
    const ComposedComponent = (props)=>{
        const Component = component;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UserProvider, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, {
                ...props
            })
        });
    };
    ComposedComponent.displayName = "withUser(".concat(component.displayName, ")");
    return ComposedComponent;
};
/**
 * @deprecated Stop using this function. All object
 */ const isUnclaimed = (obj)=>!obj.userId;


/***/ }),

/***/ 8004:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ Page; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 36 modules
var esm = __webpack_require__(692);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./src/components/icons/code.svg
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgCode = function SvgCode(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "code_svg__h-6 code_svg__w-6",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    strokeWidth: 2
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m10 20 4-16m4 4 4 4-4 4M6 16l-4-4 4-4"
  })));
};

/* harmony default export */ var code = (SvgCode);
;// CONCATENATED MODULE: ./src/components/icons/cursor-click.svg
var cursor_click_path;

function cursor_click_extends() { cursor_click_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return cursor_click_extends.apply(this, arguments); }



var SvgCursorClick = function SvgCursorClick(props) {
  return /*#__PURE__*/react.createElement("svg", cursor_click_extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "cursor-click_svg__h-6 cursor-click_svg__w-6",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    strokeWidth: 2
  }, props), cursor_click_path || (cursor_click_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m15 15-2 5L9 9l11 4-5 2zm0 0 5 5M7.188 2.239l.777 2.897M5.136 7.965l-2.898-.777M13.95 4.05l-2.122 2.122m-5.657 5.656-2.12 2.122"
  })));
};

/* harmony default export */ var cursor_click = (SvgCursorClick);
;// CONCATENATED MODULE: ./src/components/icons/server.svg
var server_path;

function server_extends() { server_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return server_extends.apply(this, arguments); }



var SvgServer = function SvgServer(props) {
  return /*#__PURE__*/react.createElement("svg", server_extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "server_svg__h-6 server_svg__w-6",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    strokeWidth: 2
  }, props), server_path || (server_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5 12h14M5 12a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2M5 12a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2m-2-4h.01M17 16h.01"
  })));
};

/* harmony default export */ var server = (SvgServer);
;// CONCATENATED MODULE: ./src/components/home/ban-ads.svg
var ban_ads_path;

function ban_ads_extends() { ban_ads_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return ban_ads_extends.apply(this, arguments); }



var SvgBanAds = function SvgBanAds(props) {
  return /*#__PURE__*/react.createElement("svg", ban_ads_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), ban_ads_path || (ban_ads_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M10 0a10 10 0 1 1 0 20 10 10 0 0 1 0-20zm4.905 3.68A8 8 0 0 0 3.68 14.906l3.296-3.296-.007-.022H5.531l-.253.835H4L5.44 8.06h1.62l.86 2.606.64-.64V8.06h1.662c.1 0 .197.004.291.013l4.393-4.393zm-4.908 7.738 1.222-1.223v.046c0 .305-.04.542-.121.712a.703.703 0 0 1-.35.36 1.32 1.32 0 0 1-.551.105h-.2zM8.99 12.423h1.248c.443 0 .828-.086 1.153-.26.325-.174.577-.424.754-.75.178-.326.266-.717.266-1.171 0-.395-.067-.74-.202-1.038l4.11-4.11A8 8 0 0 1 5.095 16.32l3.896-3.897zm5.802-3.332a.46.46 0 0 1 .16.332h1.134a1.34 1.34 0 0 0-.214-.748 1.367 1.367 0 0 0-.594-.498A2.177 2.177 0 0 0 14.365 8c-.345 0-.651.058-.918.175a1.48 1.48 0 0 0-.625.488 1.2 1.2 0 0 0-.221.726c-.002.341.108.61.33.808.223.196.528.336.914.42l.435.093c.162.036.29.074.385.115a.51.51 0 0 1 .205.137.27.27 0 0 1 .066.174.307.307 0 0 1-.068.19.43.43 0 0 1-.194.13.931.931 0 0 1-.318.047.985.985 0 0 1-.39-.07.558.558 0 0 1-.251-.207.668.668 0 0 1-.1-.337H12.49c.001.365.08.665.234.9.156.232.375.405.656.517.283.112.614.168.993.168.37 0 .686-.051.949-.155.264-.104.467-.255.609-.454a1.23 1.23 0 0 0 .215-.729 1.337 1.337 0 0 0-.08-.46 1.055 1.055 0 0 0-.242-.38 1.475 1.475 0 0 0-.421-.295 2.691 2.691 0 0 0-.62-.203l-.358-.076a1.988 1.988 0 0 1-.269-.073.836.836 0 0 1-.185-.09.345.345 0 0 1-.107-.112.278.278 0 0 1-.028-.143.289.289 0 0 1 .058-.17.361.361 0 0 1 .17-.118.854.854 0 0 1 .3-.044c.193 0 .335.04.43.119zm-8.526.17.435 1.44h-.904l.435-1.44h.034z",
    clipRule: "evenodd"
  })));
};

/* harmony default export */ var ban_ads = (SvgBanAds);
;// CONCATENATED MODULE: ./src/components/home/bonus.tsx







const Bonus = ()=>{
    const { t  } = (0,esm/* useTranslation */.$G)("homepage");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mx-auto max-w-7xl px-8 py-8",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "heading",
                children: t("principles")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "subheading",
                children: t("principlesSubheading")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "grid grid-cols-4 gap-16",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-span-4 md:col-span-2 lg:col-span-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mb-4 text-gray-400",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(cursor_click, {
                                    className: "w-16"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "heading-sm",
                                children: t("noLoginRequired")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text text-base leading-relaxed",
                                children: t("noLoginRequiredDescription")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-span-4 md:col-span-2 lg:col-span-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mb-4 text-gray-400",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(code, {
                                    className: "w-16"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "heading-sm",
                                children: t("openSource")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text text-base leading-relaxed",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Trans */.cC, {
                                    t: t,
                                    i18nKey: "openSourceDescription",
                                    components: {
                                        a: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: "text-link",
                                            href: "https://github.com/lukevella/rallly"
                                        })
                                    }
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-span-4 md:col-span-2 lg:col-span-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mb-4 text-gray-400",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(server, {
                                    className: "w-16"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "heading-sm",
                                children: t("selfHostable")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text text-base leading-relaxed",
                                children: t("selfHostableDescription")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-span-4 md:col-span-2 lg:col-span-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mb-4 text-gray-400",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ban_ads, {
                                    className: "w-16"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "heading-sm",
                                children: t("adFree")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text text-base leading-relaxed",
                                children: t("adFreeDescription")
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var bonus = (Bonus);

// EXTERNAL MODULE: ./src/components/icons/bell.svg
var bell = __webpack_require__(6394);
// EXTERNAL MODULE: ./src/components/icons/chat.svg
var chat = __webpack_require__(5850);
// EXTERNAL MODULE: ./src/components/icons/clock.svg
var clock = __webpack_require__(3697);
;// CONCATENATED MODULE: ./src/components/icons/device-mobile.svg
var device_mobile_path;

function device_mobile_extends() { device_mobile_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return device_mobile_extends.apply(this, arguments); }



var SvgDeviceMobile = function SvgDeviceMobile(props) {
  return /*#__PURE__*/react.createElement("svg", device_mobile_extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "device-mobile_svg__h-6 device-mobile_svg__w-6",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    strokeWidth: 2
  }, props), device_mobile_path || (device_mobile_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 18h.01M8 21h8a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2z"
  })));
};

/* harmony default export */ var device_mobile = (SvgDeviceMobile);
;// CONCATENATED MODULE: ./src/components/home/features.tsx







const Features = ()=>{
    const { t  } = (0,esm/* useTranslation */.$G)("homepage");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mx-auto max-w-7xl py-16 px-8",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "heading",
                children: t("features")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "subheading",
                children: t("featuresSubheading")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "grid grid-cols-2 gap-12",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-span-2 md:col-span-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mb-4 inline-block rounded-2xl bg-green-100/50 p-3 text-green-400",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(clock/* default */.Z, {
                                    className: "h-8 w-8"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                className: "heading-sm flex items-center",
                                children: [
                                    t("timeSlots"),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "ml-2 rounded-full bg-green-500 px-2 py-1 text-sm font-normal text-white",
                                        children: t("new")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text",
                                children: t("timeSlotsDescription")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-span-2 md:col-span-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mb-4 inline-block rounded-2xl bg-cyan-100/50 p-3 text-cyan-400",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(device_mobile, {
                                    className: "h-8 w-8"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "heading-sm",
                                children: t("mobileFriendly")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text",
                                children: t("mobileFriendlyDescription")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-span-2 md:col-span-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mb-4 inline-block rounded-2xl bg-rose-100/50 p-3 text-rose-400",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bell/* default */.Z, {
                                    className: "h-8 w-8"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "heading-sm",
                                children: t("notifications")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text",
                                children: t("notificationsDescription")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-span-2 md:col-span-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mb-4 inline-block rounded-2xl bg-yellow-100/50 p-3 text-yellow-400",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chat/* default */.Z, {
                                    className: "h-8 w-8"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "heading-sm",
                                children: t("comments")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text",
                                children: t("commentsDescription")
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var features = (Features);

// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 168 modules
var motion = __webpack_require__(5489);
// EXTERNAL MODULE: ./src/utils/dayjs.tsx
var utils_dayjs = __webpack_require__(4752);
// EXTERNAL MODULE: ./src/components/poll/user-avatar.tsx + 1 modules
var user_avatar = __webpack_require__(4371);
// EXTERNAL MODULE: ./src/components/date-card.tsx
var date_card = __webpack_require__(5664);
// EXTERNAL MODULE: ./src/components/poll/desktop-poll/participant-row.tsx
var participant_row = __webpack_require__(6060);
// EXTERNAL MODULE: ./src/components/poll/score-summary.tsx + 1 modules
var score_summary = __webpack_require__(9398);
;// CONCATENATED MODULE: ./src/components/home/poll-demo.tsx







const sidebarWidth = 180;
const columnWidth = 100;
const participants = [
    {
        name: "Reed",
        color: "bg-sky-400",
        votes: [
            0,
            2
        ]
    },
    {
        name: "Susan",
        color: "bg-blue-400",
        votes: [
            0,
            1,
            2
        ]
    },
    {
        name: "Johnny",
        color: "bg-primary-400",
        votes: [
            2,
            3
        ]
    },
    {
        name: "Ben",
        color: "bg-purple-400",
        votes: [
            0,
            1,
            2,
            3
        ]
    }
];
const options = [
    "2022-03-14",
    "2022-03-15",
    "2022-03-16",
    "2022-03-17"
];
const PollDemo = ()=>{
    const { t  } = (0,esm/* useTranslation */.$G)("homepage");
    const { dayjs  } = (0,utils_dayjs/* useDayjs */.a)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "rounded-lg bg-white py-1 shadow-huge",
        style: {
            width: 600
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex shrink-0 items-center py-2 pl-4 pr-2 font-medium",
                        style: {
                            width: sidebarWidth
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex h-full grow items-end",
                            children: t("participantCount", {
                                count: participants.length
                            })
                        })
                    }),
                    options.map((option, i)=>{
                        const d = new Date(option);
                        let score = 0;
                        participants.forEach((participant)=>{
                            if (participant.votes.includes(i)) {
                                score++;
                            }
                        });
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "shrink-0 space-y-3 py-2 pt-3 text-center transition-colors",
                            style: {
                                width: columnWidth
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(date_card/* default */.Z, {
                                        day: dayjs(d).format("D"),
                                        dow: dayjs(d).format("ddd"),
                                        month: dayjs(d).format("MMM")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex justify-center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(score_summary/* ScoreSummary */.D, {
                                        yesScore: score
                                    })
                                })
                            ]
                        }, i);
                    })
                ]
            }),
            participants.map((participant, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(participant_row/* ParticipantRowView */._, {
                    color: participant.color,
                    sidebarWidth: sidebarWidth,
                    columnWidth: columnWidth,
                    participantId: "participant".concat(i),
                    name: participant.name,
                    votes: options.map((_, i)=>{
                        return participant.votes.some((vote)=>vote === i) ? "yes" : "no";
                    })
                }, i))
        ]
    });
};
/* harmony default export */ var poll_demo = (PollDemo);

;// CONCATENATED MODULE: ./src/components/home/scribble-arrow.svg
var scribble_arrow_path;

function scribble_arrow_extends() { scribble_arrow_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return scribble_arrow_extends.apply(this, arguments); }



var SvgScribbleArrow = function SvgScribbleArrow(props) {
  return /*#__PURE__*/react.createElement("svg", scribble_arrow_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "currentColor"
  }, props), scribble_arrow_path || (scribble_arrow_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M1.11 2.994h.001l.014-.002a17.546 17.546 0 0 1 1.383-.055c.902 0 2.175.06 3.643.3 2.944.48 6.612 1.674 9.67 4.498 1.464 1.35 2.55 3.281 3.339 5.492.787 2.204 1.259 4.626 1.535 6.894.27 2.224.35 4.275.36 5.788l-4.245-4.83a1 1 0 1 0-1.502 1.32l5.94 6.761a1 1 0 0 0 1.412.091l6.76-5.94a1 1 0 1 0-1.32-1.503l-5.045 4.433v-.262a53.57 53.57 0 0 0-.375-6.1c-.287-2.357-.783-4.935-1.637-7.325-.85-2.383-2.078-4.64-3.865-6.289-3.44-3.176-7.523-4.483-10.704-5.002A24.842 24.842 0 0 0 2.508.938a19.54 19.54 0 0 0-1.492.056 7.207 7.207 0 0 0-.089.008l-.025.003H.89v.001L1 2l-.11-.994a1 1 0 0 0 .22 1.988",
    clipRule: "evenodd"
  })));
};

/* harmony default export */ var scribble_arrow = (SvgScribbleArrow);
;// CONCATENATED MODULE: ./src/components/home/hero.tsx
/* eslint-disable @next/next/no-html-link-for-pages */ 







const Hero = ()=>{
    const { t  } = (0,esm/* useTranslation */.$G)("homepage");
    const names = [
        "Peter",
        "Christine",
        "Samantha",
        "Joseph"
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mx-auto max-w-7xl items-end p-8 lg:flex lg:justify-between",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "my-8 text-center lg:text-left",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: "text-4xl font-bold sm:text-5xl",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Trans */.cC, {
                            t: t,
                            i18nKey: "heroText",
                            components: {
                                br: /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                s: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "whitespace-nowrap text-primary-500"
                                })
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mb-12 text-xl text-gray-400",
                        children: t("heroSubText")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "space-x-3",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "/new",
                                className: "rounded-lg bg-primary-500 px-5 py-3 font-semibold text-white shadow-sm transition-all hover:bg-primary-500/90 hover:text-white hover:no-underline hover:shadow-md focus:ring-2 focus:ring-primary-200 active:bg-primary-600/90",
                                children: t("getStarted")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "/demo",
                                className: "rounded-lg bg-slate-500 px-5 py-3 font-semibold text-white shadow-sm transition-all hover:bg-slate-500/90 hover:text-white hover:no-underline hover:shadow-md focus:ring-2 focus:ring-primary-200 active:bg-slate-600/90",
                                rel: "nofollow",
                                children: t("liveDemo")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "pointer-events-none mt-24 hidden h-[380px] select-none items-end justify-center md:flex lg:mt-8 lg:ml-8",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(user_avatar/* UserAvatarProvider */.b, {
                    seed: "mock",
                    names: names,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(utils_dayjs/* DayjsProvider */.L, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "relative inline-block",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                                    className: "absolute z-20 h-full rounded-2xl border-4 border-primary-500 bg-primary-200/10 shadow-md",
                                    initial: {
                                        opacity: 0,
                                        width: 100,
                                        scale: 1.1,
                                        x: 480
                                    },
                                    animate: {
                                        opacity: 1,
                                        x: 381
                                    },
                                    transition: {
                                        type: "spring",
                                        delay: 1
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(motion/* motion.div */.E.div, {
                                    className: "absolute z-20 rounded-full bg-primary-500 py-1 px-3 text-sm text-slate-100",
                                    initial: {
                                        opacity: 0,
                                        right: 190,
                                        top: -65,
                                        translateY: 50
                                    },
                                    animate: {
                                        opacity: 1,
                                        translateY: 0
                                    },
                                    transition: {
                                        type: "spring",
                                        delay: 2
                                    },
                                    children: [
                                        t("perfect"),
                                        " \uD83E\uDD29",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(scribble_arrow, {
                                            className: "absolute -right-8 top-3 text-slate-400"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                                    className: "rounded-lg",
                                    transition: {
                                        type: "spring",
                                        delay: 0.5
                                    },
                                    initial: {
                                        opacity: 0,
                                        translateY: -100
                                    },
                                    animate: {
                                        opacity: 1,
                                        translateY: 0
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(poll_demo, {})
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var hero = (Hero);

// EXTERNAL MODULE: ./src/components/layouts/page-layout.tsx + 10 modules
var page_layout = __webpack_require__(910);
;// CONCATENATED MODULE: ./src/components/home.tsx








const Home = ()=>{
    const { t  } = (0,esm/* useTranslation */.$G)("homepage");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(page_layout/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: t("metaTitle"),
                description: t("metaDescription"),
                twitter: {
                    handle: "@imlukevella",
                    site: "@ralllyco",
                    cardType: "summary_large_image"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(hero, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(features, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(bonus, {})
        ]
    });
};
/* harmony default export */ var home = (Home);

;// CONCATENATED MODULE: ./src/pages/home.tsx


var __N_SSP = true;
function Page() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(home, {});
}


/***/ }),

/***/ 4752:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ DayjsProvider; },
/* harmony export */   "a": function() { return /* binding */ useDayjs; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var dayjs_plugin_duration__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1646);
/* harmony import */ var dayjs_plugin_duration__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_duration__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var dayjs_plugin_isBetween__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6607);
/* harmony import */ var dayjs_plugin_isBetween__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_isBetween__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var dayjs_plugin_isSameOrBefore__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7412);
/* harmony import */ var dayjs_plugin_isSameOrBefore__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_isSameOrBefore__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var dayjs_plugin_localeData__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6036);
/* harmony import */ var dayjs_plugin_localeData__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_localeData__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var dayjs_plugin_localizedFormat__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6176);
/* harmony import */ var dayjs_plugin_localizedFormat__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_localizedFormat__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var dayjs_plugin_minMax__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7181);
/* harmony import */ var dayjs_plugin_minMax__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_minMax__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var dayjs_plugin_relativeTime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4110);
/* harmony import */ var dayjs_plugin_relativeTime__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_relativeTime__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var dayjs_plugin_timezone__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9387);
/* harmony import */ var dayjs_plugin_timezone__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_timezone__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var dayjs_plugin_utc__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(178);
/* harmony import */ var dayjs_plugin_utc__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_utc__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(692);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(7294);
/* harmony import */ var react_use__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(584);
/* harmony import */ var react_use__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(5533);
/* harmony import */ var _components_use_required_context__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(8355);















const dayjsLocales = {
    en: {
        weekStartsOn: "monday",
        timeFormat: "12h",
        import: ()=>__webpack_require__.e(/* import() */ 5054).then(__webpack_require__.t.bind(__webpack_require__, 5054, 23))
    },
    es: {
        weekStartsOn: "monday",
        timeFormat: "24h",
        import: ()=>__webpack_require__.e(/* import() */ 7763).then(__webpack_require__.t.bind(__webpack_require__, 7763, 23))
    },
    ca: {
        weekStartsOn: "monday",
        timeFormat: "24h",
        import: ()=>__webpack_require__.e(/* import() */ 3646).then(__webpack_require__.t.bind(__webpack_require__, 3646, 23))
    },
    da: {
        weekStartsOn: "monday",
        timeFormat: "24h",
        import: ()=>__webpack_require__.e(/* import() */ 7427).then(__webpack_require__.t.bind(__webpack_require__, 7427, 23))
    },
    de: {
        weekStartsOn: "monday",
        timeFormat: "24h",
        import: ()=>__webpack_require__.e(/* import() */ 790).then(__webpack_require__.t.bind(__webpack_require__, 790, 23))
    },
    fi: {
        weekStartsOn: "monday",
        timeFormat: "24h",
        import: ()=>__webpack_require__.e(/* import() */ 7822).then(__webpack_require__.t.bind(__webpack_require__, 7822, 23))
    },
    fr: {
        weekStartsOn: "monday",
        timeFormat: "24h",
        import: ()=>__webpack_require__.e(/* import() */ 6023).then(__webpack_require__.t.bind(__webpack_require__, 6023, 23))
    },
    hr: {
        weekStartsOn: "monday",
        timeFormat: "24h",
        import: ()=>__webpack_require__.e(/* import() */ 6257).then(__webpack_require__.t.bind(__webpack_require__, 6257, 23))
    },
    it: {
        weekStartsOn: "monday",
        timeFormat: "24h",
        import: ()=>__webpack_require__.e(/* import() */ 5551).then(__webpack_require__.t.bind(__webpack_require__, 5551, 23))
    },
    sv: {
        weekStartsOn: "monday",
        timeFormat: "24h",
        import: ()=>__webpack_require__.e(/* import() */ 1876).then(__webpack_require__.t.bind(__webpack_require__, 1876, 23))
    },
    sk: {
        weekStartsOn: "monday",
        timeFormat: "24h",
        import: ()=>__webpack_require__.e(/* import() */ 5627).then(__webpack_require__.t.bind(__webpack_require__, 5627, 23))
    },
    cs: {
        weekStartsOn: "monday",
        timeFormat: "24h",
        import: ()=>__webpack_require__.e(/* import() */ 8507).then(__webpack_require__.t.bind(__webpack_require__, 8507, 23))
    },
    pl: {
        weekStartsOn: "monday",
        timeFormat: "24h",
        import: ()=>__webpack_require__.e(/* import() */ 1987).then(__webpack_require__.t.bind(__webpack_require__, 1987, 23))
    },
    pt: {
        weekStartsOn: "monday",
        timeFormat: "24h",
        import: ()=>__webpack_require__.e(/* import() */ 5001).then(__webpack_require__.t.bind(__webpack_require__, 5001, 23))
    },
    "pt-BR": {
        weekStartsOn: "sunday",
        timeFormat: "24h",
        import: ()=>__webpack_require__.e(/* import() */ 7548).then(__webpack_require__.t.bind(__webpack_require__, 7548, 23))
    },
    ru: {
        weekStartsOn: "monday",
        timeFormat: "24h",
        import: ()=>__webpack_require__.e(/* import() */ 600).then(__webpack_require__.t.bind(__webpack_require__, 600, 23))
    },
    ko: {
        weekStartsOn: "sunday",
        timeFormat: "12h",
        import: ()=>__webpack_require__.e(/* import() */ 9132).then(__webpack_require__.t.bind(__webpack_require__, 9132, 23))
    },
    nl: {
        weekStartsOn: "monday",
        timeFormat: "24h",
        import: ()=>__webpack_require__.e(/* import() */ 9182).then(__webpack_require__.t.bind(__webpack_require__, 9182, 23))
    },
    hu: {
        weekStartsOn: "monday",
        timeFormat: "24h",
        import: ()=>__webpack_require__.e(/* import() */ 8562).then(__webpack_require__.t.bind(__webpack_require__, 8562, 23))
    },
    zh: {
        weekStartsOn: "monday",
        timeFormat: "24h",
        import: ()=>__webpack_require__.e(/* import() */ 2009).then(__webpack_require__.t.bind(__webpack_require__, 2009, 23))
    }
};
dayjs__WEBPACK_IMPORTED_MODULE_1___default().extend((dayjs_plugin_localizedFormat__WEBPACK_IMPORTED_MODULE_6___default()));
dayjs__WEBPACK_IMPORTED_MODULE_1___default().extend((dayjs_plugin_relativeTime__WEBPACK_IMPORTED_MODULE_8___default()));
dayjs__WEBPACK_IMPORTED_MODULE_1___default().extend((dayjs_plugin_localeData__WEBPACK_IMPORTED_MODULE_5___default()));
dayjs__WEBPACK_IMPORTED_MODULE_1___default().extend((dayjs_plugin_isSameOrBefore__WEBPACK_IMPORTED_MODULE_4___default()));
dayjs__WEBPACK_IMPORTED_MODULE_1___default().extend((dayjs_plugin_isBetween__WEBPACK_IMPORTED_MODULE_3___default()));
dayjs__WEBPACK_IMPORTED_MODULE_1___default().extend((dayjs_plugin_minMax__WEBPACK_IMPORTED_MODULE_7___default()));
dayjs__WEBPACK_IMPORTED_MODULE_1___default().extend((dayjs_plugin_utc__WEBPACK_IMPORTED_MODULE_10___default()));
dayjs__WEBPACK_IMPORTED_MODULE_1___default().extend((dayjs_plugin_timezone__WEBPACK_IMPORTED_MODULE_9___default()));
dayjs__WEBPACK_IMPORTED_MODULE_1___default().extend((dayjs_plugin_duration__WEBPACK_IMPORTED_MODULE_2___default()));
const DayjsContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_12__.createContext(null);
const useDayjs = ()=>{
    return (0,_components_use_required_context__WEBPACK_IMPORTED_MODULE_13__/* .useRequiredContext */ .a)(DayjsContext);
};
const DayjsProviderInner = (param)=>{
    let { children  } = param;
    const { i18n  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_11__/* .useTranslation */ .$G)();
    // Using language instead of router.locale because when transitioning from homepage to
    // the app via <Link locale={false}> it will be set to "en" instead of the current locale.
    const localeConfig = dayjsLocales[i18n.language];
    const [weekStartsOn = localeConfig.weekStartsOn, setWeekStartsOn] = (0,react_use__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)("rallly-week-starts-on");
    const [timeFormat = localeConfig.timeFormat, setTimeFormat] = (0,react_use__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)("rallly-time-format");
    const { value: dayjsLocale  } = (0,react_use__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(async ()=>{
        return await localeConfig.import();
    }, [
        localeConfig
    ]);
    if (!dayjsLocale) {
        // wait for locale to load before rendering content
        return null;
    }
    dayjs__WEBPACK_IMPORTED_MODULE_1___default().locale({
        ...dayjsLocale,
        weekStart: weekStartsOn ? weekStartsOn === "monday" ? 1 : 0 : dayjsLocale.weekStart,
        formats: localeConfig.timeFormat !== timeFormat ? {
            ...dayjsLocale.formats,
            LT: timeFormat === "12h" ? "h:mm A" : "HH:mm"
        } : dayjsLocale.formats
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DayjsContext.Provider, {
        value: {
            dayjs: (dayjs__WEBPACK_IMPORTED_MODULE_1___default()),
            weekStartsOn: weekStartsOn !== null && weekStartsOn !== void 0 ? weekStartsOn : localeConfig.weekStartsOn,
            timeFormat: timeFormat !== null && timeFormat !== void 0 ? timeFormat : localeConfig.timeFormat,
            setWeekStartsOn,
            setTimeFormat
        },
        children: children
    });
};
const DayjsProvider = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DayjsProviderInner, {
        children: children
    });
};


/***/ }),

/***/ 6001:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ requiredString; },
/* harmony export */   "u": function() { return /* binding */ validEmail; }
/* harmony export */ });
const requiredString = (value)=>!!value.trim();
const validEmail = (value)=>/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(value);


/***/ }),

/***/ 7176:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ usePrevious; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

function usePrevious(state) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        ref.current = state;
    });
    return ref.current;
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [160,3662,1664,428,5008,9087,4722,910,9774,2888,179], function() { return __webpack_exec__(4309); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);